"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseQuery_1 = require("./BaseQuery");

var typeChecks_1 = require("../utils/typeChecks");

var ScenarioQuery =
/** @class */
function (_super) {
  __extends(ScenarioQuery, _super);

  function ScenarioQuery() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ScenarioQuery.prototype.initialize = function (executionOptions) {
    this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
    this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
  };

  ScenarioQuery.prototype.getOptions = function () {
    var _a = this.queryOptions,
        code = _a.code,
        codeQuery = _a.codeQuery,
        key = _a.key,
        keyQuery = _a.keyQuery,
        _b = _a.options,
        options = _b === void 0 ? {} : _b;
    return __assign({
      code: code,
      codeQuery: codeQuery,
      key: key,
      keyQuery: keyQuery
    }, options.scenario || {});
  };

  ScenarioQuery.prototype.getRawValue = function (executionOptions) {
    var _a = this.queryOptions,
        code = _a.code,
        key = _a.key;
    var instance = this.getScenarioFromContext(executionOptions);

    if (typeChecks_1.isObject(instance) && code) {
      if (code === 'extended') {
        if (typeChecks_1.isObject(instance.extended)) {
          return instance.extended[key];
        }
      } else {
        return instance[code];
      }
    }

    return undefined;
  };

  return ScenarioQuery;
}(BaseQuery_1.BaseQuery);

exports.ScenarioQuery = ScenarioQuery;